<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>推广管理</a-breadcrumb-item>
    <a-breadcrumb-item>服务商管理</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <a-col :span="6">
        <a-row>
          <!-- 服务商： -->
          <a-col :span="6" class="tool-title">服务商：</a-col>
          <a-col :span="18">
            <a-input v-model:value="nameModel" class="tool-item" placeholder="请输入名称" />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <!-- 操作 -->
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <!-- 保留布局结构 -->
      </a-col>
      <a-col :span="6">
        <a-row>
          <!-- 操作 -->
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap; text-align: right;">
            <a-button type="primary" @click="touchAdd"><plus-outlined /> 添加服务商</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 操作 -->
       <template v-if="column.key === 'created_at'">
        <a-tooltip :title="getFullDateTime(record[column.key])" placement="top">
          <span>{{ getShortDate(record[column.key]) }}</span>
        </a-tooltip>
      </template>
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchEdit(record)">编辑</a>
        <a class="operation-item" @click="touchInterfaceParams(record)">接口参数</a>
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
  
  <!-- 服务商弹窗 -->
  <ServiceProviderDrawer ref="RefServiceProviderDrawer" @success="getServiceProviderList"></ServiceProviderDrawer>
</template>

<script setup>
import { onBeforeMount, reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
// 引入 dayjs 及 扩展函数
import dayjs from 'dayjs'
// 引入公共方法
import Pub from '@/utils/public'
// 引入弹窗组件
import ServiceProviderDrawer from './components/ServiceProviderDrawer'
// 引入 API
import { serviceProviderList } from '@/api/admin'

// 弹窗引用
let RefServiceProviderDrawer = ref(null)
// 服务商名称
let name = ref(undefined)
let nameModel = ref(undefined)
// 状态（已移除）
// let status = ref(undefined)
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '服务商ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '服务商名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'AD识别码',
    dataIndex: 'adj_id',
    key: 'adj_id'
  },
  {
    title: 'AD短链识别码',
    dataIndex: 'adj_linkid',
    key: 'adj_linkid'
  },
  {
    title: '达人备案数量',
    dataIndex: 'daren_count',
    key: 'daren_count'
  },
  {
    title: '推广链接数量',
    dataIndex: 'ad_count',
    key: 'ad_count'
  },
  {
    title: '入库日期',
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

onBeforeMount (() => {
  // 初始化获取
  touchSearch()
})

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getServiceProviderList()
}

// 查询
function touchSearch () {
  // 调整参数
  name.value = nameModel.value
  pagination.current = 1
  // 获取列表
  getServiceProviderList()
}

// 重置
function touchReset () {
  nameModel.value = undefined
  name.value = undefined
  // 初始化获取
  touchSearch()
}

// 新建
function touchAdd () {
  // 显示新建弹窗
  RefServiceProviderDrawer.value.showDrawer()
}

// 编辑
function touchEdit (record) {
  // 显示编辑弹窗，传入记录数据
  RefServiceProviderDrawer.value.showDrawer(record)
}

// 接口参数
function touchInterfaceParams (record) {
  // 格式化为带排版的JSON字符串
  const jsonString = JSON.stringify(record.appkey || {}, null, 2)
  // 复制到剪贴板
  Pub.COPY(jsonString)
}

// 获取列表
function getServiceProviderList () {
  isLoading.value = true
  const params = {
    name: name.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  // TODO: 替换为实际的API调用
  serviceProviderList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 获取短日期格式 (YYYY-MM-DD)
function getShortDate (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD')
}

// 获取完整日期时间格式 (YYYY-MM-DD HH:mm:ss)
function getFullDateTime (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD HH:mm:ss')
}
</script>

<style scoped>

.tool-row {
  margin-bottom: 16px;
}

.tool-title {
  text-align: right;
}

.tool-item {
  width: 100%;
}

.table-view {
  background: #fff;
  border-radius: 6px;
}

.operation-item {
  color: #1890ff;
  margin-right: 16px;
  cursor: pointer;
}

.operation-item:hover {
  color: #40a9ff;
}
</style>
